// The kEditableTable stylesheet text (kEditableTable._Css, injected by AddStyles), moved out of
// kEditableTable.ts by the size split of 2026-10-20. Unchanged text.
export const kEditableTableCssText: string = `
                  .kEditableTable {
                      border: 1px solid #d1d1d1 !important;
                      font-size: 9pt !important;
                      font-family: 'Segoe UI', 'Aptos Narrow', sans-serif !important;
                      border-spacing: 0 !important;
                      border-collapse: collapse !important;
                      float: left;
                      white-space: nowrap !important;
                  }
                  .kEditableTable:focus { outline: none; }
                  .kEditableTable:focus-visible { outline: 2px solid #0f6cbd !important; outline-offset: 2px; }
                  .kEditableTable th {
                      background-color: #f2f2f2 !important;
                      border: 0 !important;
                      border-bottom: 1px solid #c8c8c8 !important;
                      border-right: 1px solid #d1d1d1 !important;
                      font-weight: 600 !important;
                      font-size: 9pt !important;
                      color: #323130 !important;
                      padding: 2px 6px !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      user-select: none;
                      position: sticky;
                      top: 0;
                      z-index: 2;
                  }
                  .kEditableTableRow {
                      display: table-row;
                      background: transparent !important;
                      border: 0 !important;
                      padding: 0 !important;
                      margin: 0 !important;
                      height: auto !important;
                  }
                  .kRowNumberHeading {
                      background-color: #f2f2f2 !important;
                      border: 0 !important;
                      border-bottom: 1px solid #c8c8c8 !important;
                      border-right: 1px solid #d1d1d1 !important;
                      font-weight: 400 !important;
                      font-size: 9pt !important;
                      text-align: center !important;
                      user-select: none;
                      color: #666666 !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      width: 8px;
                      position: sticky;
                      top: 0;
                      left: 0;
                      z-index: 1;
                  }
                  .kRowNumText {
                      vertical-align: middle;
                  }
                  .kEditableTableCell {
                      background-color: white !important;
                      padding: 1px 6px !important;
                      border-bottom: 1px solid #e8e8e8 !important;
                      border-right: 1px solid #e8e8e8 !important;
                      height: 20px !important;
                      font-size: 9pt !important;
                      font-weight: normal !important;
                      color: #323130 !important;
                      white-space: nowrap !important;
                      vertical-align: middle !important;
                      line-height: normal !important;
                      user-select: none;
                      position: relative;
                  }
                  .kValidationIcon {
                      position: absolute;
                      right: 2px;
                      top: 1px;
                      color: #d13438;
                      font-size: 10px;
                      pointer-events: none;
                      line-height: 1;
                  }
                  .kEditableTableCell:hover:not(.SelectedCellSingle):not(.SelectedCellMulti):not(.SelectedFirstRow) {
                      background-color: #f5f5f5 !important;
                  }
                  /* Selection is drawn WITHOUT background-color, so it survives a
                     column TintColor / per-cell status colour / numeric data-bar
                     (all set background inline-important and would otherwise hide a
                     background-based selection). The fill is a translucent inset
                     box-shadow "wash" that composites OVER any background; the range
                     perimeter is a dashed border painted by an ::after overlay
                     (see td.kSelEdge* below). */
                  td.SelectedCellSingle {
                      box-shadow: inset 0 0 0 1000px rgba(0, 120, 212, 0.18);
                      outline: 1px solid #0078d4 !important;
                      outline-offset: -1px;
                  }
                  td.SelectedCellMulti {
                      box-shadow: inset 0 0 0 1000px rgba(0, 120, 212, 0.14);
                  }
                  td.SelectedFirstRow {
                      box-shadow: inset 0 0 0 1000px rgba(0, 120, 212, 0.26);
                  }
                  /* Dashed selection-range perimeter. Painted as an ::after overlay —
                     cells are position:relative — so it never shifts layout and paints
                     above any cell background. A corner cell carries two edge classes,
                     so its single ::after gets two dashed sides. */
                  td.kSelEdgeTop::after,
                  td.kSelEdgeRight::after,
                  td.kSelEdgeBottom::after,
                  td.kSelEdgeLeft::after {
                      content: "";
                      position: absolute;
                      inset: 0;
                      pointer-events: none;
                      z-index: 3;
                  }
                  td.kSelEdgeTop::after    { border-top: 2px dashed #0078d4; }
                  td.kSelEdgeRight::after  { border-right: 2px dashed #0078d4; }
                  td.kSelEdgeBottom::after { border-bottom: 2px dashed #0078d4; }
                  td.kSelEdgeLeft::after   { border-left: 2px dashed #0078d4; }
                  .kEditableTableCell .highlighted {
                      background-color: #8a8886;
                  }
                  .kEditableTableCell .heading {
                      background-color: #f2f2f2;
                      border-bottom: 1px solid #c8c8c8;
                      border-right: 1px solid #d1d1d1;
                      text-align: center;
                      padding: 0;
                      user-select: none;
                  }
                  /* Sizing carries !important so a host page's global control CSS
                     (SharePoint core15.css styles every <select>/<input>, often with
                     !important) cannot pull the editor back to its intrinsic box and
                     resize the cell. min-width:0 defeats a native control's content-based
                     minimum (the <select>'s widest option, the colour <input>'s ~44px). */
                  .kEditableTableCell select,
                  .kEditableTableCell input[type="text"],
                  .kEditableTableCell input[type="number"],
                  .kEditableTableCell input[type="date"] {
                      height: 20px !important;
                      box-sizing: border-box !important;
                      border: none !important;
                      padding: 0 4px !important;
                      margin: 0 !important;
                      min-width: 0 !important;
                      max-width: 100% !important;
                      font-family: inherit;
                      font-size: inherit;
                      color: inherit;
                      background: transparent;
                      outline: none;
                      width: 100% !important;
                  }
                  .kEditableTableCell:has(select),
                  .kEditableTableCell:has(input) {
                      padding: 0 !important;
                  }
                  /* A row that is read-only WHILE ITS NEIGHBOURS ARE NOT. The grey-italic treatment
                     is a CONTRAST cue - it says "this one, not those" - and it only means that when
                     there is something to contrast against. */
                  .kEditableTableRowReadOnly td {
                      background-color: #f5f5f5 !important;
                      color: #a0a0a0 !important;
                      cursor: default !important;
                      font-style: italic !important;
                  }
                  .kEditableTableRowReadOnly td:hover:not(.SelectedCellSingle):not(.SelectedCellMulti) {
                      background-color: #f5f5f5 !important;
                  }
                  /* A WHOLE-TABLE READ-ONLY GRID IS NOT A DISABLED ONE (owner, 2026-08-26: "The
                     table view should not render as disabled, lively but not editable").
                     SetReadOnly(true) marks EVERY row read-only, so before this rule every cell in
                     such a grid was grey-on-grey and italic - the visual language of a control that
                     is switched off. There is no contrast left to draw when every row is locked, and
                     the grid's whole job in that mode is READING, which is the one thing greyed
                     italic text is worst for. The cue is withdrawn and the grid reads as an ordinary
                     table nobody may type into.
                     SCOPED TO THE WHOLE-TABLE CASE ONLY: a grid that locks SOME rows keeps the
                     treatment above unchanged - that is the case the cue was written for, and every
                     existing consumer of per-row locking is untouched.
                     cursor:default is deliberately NOT restored to a text caret. Lively is about
                     legibility, not about pretending the cell can be typed into. */
                  .kEditableTableReadOnly .kEditableTableRowReadOnly td {
                      background-color: inherit !important;
                      color: inherit !important;
                      font-style: normal !important;
                  }
                  .kEditableTableReadOnly .kEditableTableRowReadOnly td:hover:not(.SelectedCellSingle):not(.SelectedCellMulti) {
                      background-color: inherit !important;
                  }
                  .kEdTblRichHtmlCell {
                      overflow: hidden !important;
                      text-overflow: ellipsis;
                  }
                  .kEdTblRichHtmlCell p,
                  .kEdTblRichHtmlCell div,
                  .kEdTblRichHtmlCell ul,
                  .kEdTblRichHtmlCell ol,
                  .kEdTblRichHtmlCell li,
                  .kEdTblRichHtmlCell h1,
                  .kEdTblRichHtmlCell h2,
                  .kEdTblRichHtmlCell h3,
                  .kEdTblRichHtmlCell h4 {
                      display: inline;
                      margin: 0 !important;
                      padding: 0 !important;
                      font-size: inherit !important;
                      line-height: inherit !important;
                  }
                  .kEdTblRichHtmlCell svg,
                  .kEdTblRichHtmlCell img {
                      max-height: 18px !important;
                      width: auto !important;
                      vertical-align: middle;
                  }
                  /* The table floats left: without clear, a table NARROWER than its container
                     lets the footer's "N rows" flow beside it (SPArchive 1.0.2.6, live). */
                  .kEditableTableFooter {
                      clear: both;
                  }
                  .kEditableTablePagination {
                      clear: both;
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      padding: 6px 4px;
                      font-family: 'Segoe UI', 'Aptos Narrow', sans-serif;
                      font-size: 9pt;
                      color: #323130;
                  }
                  .kEditableTablePageBtn {
                      font-family: inherit;
                      font-size: inherit;
                      padding: 3px 12px;
                      border: 1px solid #c8c8c8;
                      border-radius: 3px;
                      background: #ffffff;
                      color: #323130;
                      cursor: pointer;
                  }
                  .kEditableTablePageBtn:hover:not(:disabled) {
                      background: #f2f2f2;
                  }
                  .kEditableTablePageBtn:disabled {
                      opacity: 0.4;
                      cursor: default;
                  }
                  .kEditableTablePageInfo {
                      min-width: 90px;
                      text-align: center;
                  }
                  /* Animated checkbox (discreet grey-blue). The tick is ALWAYS in the
                     DOM; .kEdChkOn shows it (stroke-dashoffset 0) and its absence hides
                     it (dashoffset 24), so an unchecked box shows no tick at rest. On a
                     real user toggle the click handler adds .kEdChkDraw (check: tick
                     draws in 24->0 + box pop) or .kEdChkUndraw (uncheck: tick reverse-
                     wipes 0->24 + box settle) to the freshly painted node so the
                     keyframes run on first paint; bulk repaints (load, paste, fill-
                     down, sort, filter) stay static. Tick + checked-box border are dark
                     blue #222B33, checked fill is light blue #C3CFDB (set inline in
                     _CheckboxHtml). Inspired by the "majestic checkbox" CodePen. */
                  .kEdChkPath {
                      stroke-dasharray: 24;
                      stroke-dashoffset: 24;
                  }
                  .kEdChkOn .kEdChkPath {
                      stroke-dashoffset: 0;
                  }
                  .kEdChkDraw .kEdChkPath {
                      animation: kEdChkDrawStroke 420ms cubic-bezier(0.65, 0, 0.45, 1) both;
                  }
                  .kEdChkUndraw .kEdChkPath {
                      animation: kEdChkUndrawStroke 320ms cubic-bezier(0.55, 0, 0.35, 1) both;
                  }
                  .kEdChkDraw.kEdChkOn {
                      animation: kEdChkPop 300ms cubic-bezier(0.34, 1.56, 0.64, 1) both;
                  }
                  .kEdChkUndraw {
                      animation: kEdChkPopOut 280ms cubic-bezier(0.34, 1.4, 0.64, 1) both;
                  }
                  @keyframes kEdChkDrawStroke {
                      from { stroke-dashoffset: 24; }
                      to   { stroke-dashoffset: 0; }
                  }
                  @keyframes kEdChkUndrawStroke {
                      from { stroke-dashoffset: 0; }
                      to   { stroke-dashoffset: 24; }
                  }
                  @keyframes kEdChkPop {
                      0%   { transform: scale(0.8); }
                      55%  { transform: scale(1.12); }
                      100% { transform: scale(1); }
                  }
                  @keyframes kEdChkPopOut {
                      0%   { transform: scale(1); }
                      45%  { transform: scale(0.86); }
                      100% { transform: scale(1); }
                  }
                  /* No prefers-reduced-motion opt-out by design: these are tiny
                     functional micro-interactions (a ~0.4s tick draw/wipe + a small
                     pop on an 18px control), kept ON everywhere at the product owner's
                     request. Windows Server reports reduced-motion by default
                     (animations off), so gating them there would hide them entirely.
                     To suppress in a future host, re-add:
                     @media (prefers-reduced-motion: reduce) {
                         .kEdChkDraw.kEdChkOn, .kEdChkUndraw,
                         .kEdChkDraw .kEdChkPath, .kEdChkUndraw .kEdChkPath { animation: none; }
                     } */
                  /* Toolbar defaults (2026-09-24). ToContainer draws div.kEditableTableToolbar
                     holding input.kEditableTableFilter, and kEditableTableFilterUI adds
                     button.kFilterAdvancedBtn to it, but until now nothing styled them, so every
                     product restyled the same three elements from scratch. The container sits
                     inside :where() so these rules weigh ONE class (0,1,0): they beat a host
                     page's bare element rules (input, button) but lose to any product's own
                     scoped rule, e.g. ".spa-grid .kEditableTableFilter". Do not raise it. */
                  :where(.kEditableTableToolbar) {
                      display: flex;
                      align-items: center;
                      gap: 8px;
                      margin-bottom: 8px;
                      flex-wrap: wrap;
                  }
                  :where(.kEditableTableToolbar) .kEditableTableFilter {
                      border: 1px solid #c8c8c8;
                      border-radius: 4px;
                      padding: 5px 8px;
                      font-size: 13px;
                      font-family: inherit;
                      min-width: 200px;
                      box-sizing: border-box;
                  }
                  :where(.kEditableTableToolbar) .kFilterAdvancedBtn {
                      border: 1px solid #c8c8c8;
                      border-radius: 4px;
                      background: #fff;
                      padding: 5px 12px;
                      font-size: 13px;
                      font-family: inherit;
                      cursor: pointer;
                  }
                  `;
